/** @file Account selector shown after email OTP login when multiple accounts share an email. */
import p from 'vue-strict-prop';
import * as tsx from 'vue-tsx-support';
import * as icons from '@codegrade/icons';
import * as actionTile from '@/components/ActionTile';
/** Renders the list of accounts the user may select to continue their OTP login. */
export const SelectAccount = tsx.component({
    name: 'select-account',
    props: {
        accounts: p.ofRoArray().required,
        select: p.ofFunction().required,
    },
    /** @returns The rendered account selection list JSX. */
    render() {
        return (<div class="flex flex-col gap-1">
                <p class="body-medium mb-4">
                    This email is associated with the following accounts. Please select one to
                    continue login.{' '}
                </p>
                {this.accounts.map(acc => {
                const tenantName = acc.tenant.map(t => t.name).orDefault('');
                return (<actionTile.Single class="w-full" key={acc.userId} title={acc.username} description={tenantName} action={{
                        tag: 'call-async',
                        icon: icons.ArrowRight,
                        action: async () => await this.select(acc),
                        loadingAlertMessage: acc.tenant.caseOf({
                            Just: t => `Logging in as ${acc.username} on ${t.name}`,
                            Nothing: () => `Logging in ${acc.username}`,
                        }),
                        successAlertMessage: '',
                    }}/>);
            })}
            </div>);
    },
});
